module.exports = __webpack_public_path__ + "img/young-man-avatar.61188764.png";